// Port of api/fuel/app/classes/controller/api/monty/tags/remove.php
import DB from 'offline/db'
import {
	attachField,
	loadOwnedTag,
	persist,
	sessionUserId,
	touchAttachmentCounts,
	unauthorised,
	uniqueIndex
} from './shared'

export default function(params) {
	var userId = sessionUserId(params)
	var tag = false
	var field = false
	var index = uniqueIndex(params.index || [])
	var familyId = 0

	if (!userId) {
		return unauthorised()
	}

	tag = loadOwnedTag(userId, params.tag)
	if (!tag) {
		return unauthorised()
	}

	field = attachField(parseInt(tag.tag_context, 10) || 0)
	if (!field) {
		return unauthorised()
	}

	if (index.length) {
		DB.run('DELETE FROM tag_attach WHERE tag_id = ? AND ' + field + ' IN (' + index.map(function() { return '?' }).join(', ') + ')', [
			parseInt(tag.tag_id, 10) || 0
		].concat(index))
	}

	familyId = parseInt(tag.family_id, 10) || 0
	touchAttachmentCounts([tag.tag_id], familyId ? [familyId] : [])

	return persist({ index: index })
}
